/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_In_Info_Edit_BtnInputs */

const vi_scl_in_info_edit_btn = /** @type {(inputs: Scl_In_Info_Edit_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa thông tin`)
};

/**

* @param {Scl_In_Info_Edit_BtnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_in_info_edit_btn = /** @type {((inputs?: Scl_In_Info_Edit_BtnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_In_Info_Edit_BtnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_in_info_edit_btn(inputs)
});